import { useMemo, useRef } from 'react'
import { Box, Button, Typography } from '@mui/material'
import EditableInput from './EditableInput'

const UploadStepInput = ({
  stepId,
  value,
  uploadMeta,
  onSave,
  onUpload,
  isUploading = false,
}) => {
  const fileInputRef = useRef(null)

  const fileName = useMemo(() => {
    if (!value) return ''
    const parts = String(value).split('/')
    return parts[parts.length - 1] || value
  }, [value])

  const displayName = uploadMeta?.originalName || fileName
  const downloadUrl = uploadMeta?.url

  const openFileDialog = (event) => {
    event.stopPropagation()
    if (!isUploading) {
      fileInputRef.current?.click()
    }
  }

  const handleFileChange = (event) => {
    event.stopPropagation()
    const file = event.target.files?.[0]
    if (file && onUpload) {
      onUpload(file)
    }
    // Allow selecting the same file again later
    event.target.value = ''
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <EditableInput
        key={stepId}
        value={value || ''}
        onSave={onSave}
        disabled={false}
        showRandomOptions={true}
        isUpload={true}
      />
      <Box sx={{ display: 'flex', alignItems: 'center', columnGap: 1 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={openFileDialog}
          disabled={isUploading}
        >
          {isUploading ? 'Uploading…' : 'Upload file'}
        </Button>
        {displayName ? (
          <Typography variant="caption" color="text.secondary">
            Current: {displayName}
          </Typography>
        ) : null}
        {downloadUrl ? (
          <Button
            variant="text"
            size="small"
            href={downloadUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open
          </Button>
        ) : null}
      </Box>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
        accept='*/*'
      />
    </Box>
  )
}

export default UploadStepInput
